<template>
  <main class="app-main">
    <keep-alive>
      <router-view />
    </keep-alive>
  </main>
</template>

<script>
export default {
    name: 'OnBoarding',
}
</script>
